import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FLEET } from "../mock";
import Reveal from "./Reveal";

const Fleet = () => {
  return (
    <section id="fleet" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <Reveal as="h2" className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533]">
          {FLEET.title}
        </Reveal>
        <Reveal as="p" delay={80} className="font-body text-[#5A607A] max-w-sm">
          {FLEET.subtitle}
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {FLEET.items.map((car, i) => (
          <Reveal
            key={car.name}
            delay={(i % 3) * 90}
            className="group rounded-3xl overflow-hidden border border-[#E9E5DE] bg-white flex flex-col cursor-pointer hover:border-[#2B4BFF] transition-colors"
          >
            <Link to={car.link} data-testid={`fleet-card-${i}`} className="flex flex-col h-full">
              <div className="h-60 overflow-hidden bg-[#0B1533]">
                <img
                  src={car.img}
                  alt={car.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
              <div className="p-6 flex items-end justify-between">
                <div>
                  <span className="font-heading font-semibold text-2xl tracking-tight text-[#0B1533]">
                    {car.name}
                  </span>
                  <p className="font-body text-sm text-[#5A607A] mt-1">{car.model}</p>
                </div>
                <span className="font-body text-sm text-[#5A607A] shrink-0">{car.seats}</span>
              </div>
              <div className="px-6 pb-6 mt-auto">
                <span className="inline-flex items-center gap-1.5 font-body text-sm font-semibold text-[#2B4BFF]">
                  Mehr erfahren
                  <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Fleet;
